import type { ValuesType } from 'utility-types'

import { executeOnce, type ReadonlyRecord } from '..'

export const createIsEnumOf = <Enum extends ReadonlyRecord<string, string | number>>(e: Enum): ((v: unknown) => v is ValuesType<Enum>) => {
    const getEnumValuesSet = executeOnce(() => new Set<unknown>(Object.values(e) as ValuesType<Enum>[]))

    return (v): v is ValuesType<Enum> => getEnumValuesSet().has(v)
}
